import { useState } from "react";
import { characterImageUrl } from "../api";

const initials = (name) =>
  name.replace(/\(.*?\)/g, "").trim().split(/\s+/).slice(0, 2).map((w) => w[0]).join("").toUpperCase();

// Shows the AI-painted character portrait; falls back to gradient initials
// while loading or if the image isn't generated yet.
export default function CharacterAvatar({ cid, name, gradient, className = "", textClassName = "" }) {
  const [failed, setFailed] = useState(false);
  const [loaded, setLoaded] = useState(false);

  return (
    <span className={`relative overflow-hidden bg-gradient-to-br ${gradient} ${className}`}>
      <span
        className={`font-serif-display flex h-full w-full items-center justify-center font-semibold text-white ${textClassName} ${loaded && !failed ? "opacity-0" : "opacity-100"}`}
      >
        {initials(name)}
      </span>
      {!failed && (
        <img
          src={`${characterImageUrl(cid)}?size=thumb`}
          alt={name}
          loading="lazy"
          onLoad={() => setLoaded(true)}
          onError={() => setFailed(true)}
          className={`absolute inset-0 h-full w-full object-cover transition-opacity duration-500 ${loaded ? "opacity-100" : "opacity-0"}`}
        />
      )}
    </span>
  );
}
